module.exports = __webpack_public_path__ + "static/img/banner.96210e5d.png";